import React, { useState, createContext } from 'react'

interface ProviderProps {
  children: any
}

const ApplicationContext = createContext(null)

export function ContextProvider({ children }: ProviderProps) {
  const [darkMode, setDarkMode] = useState(false)

  return <ApplicationContext.Provider value={{ darkMode, setDarkMode }}>{children}</ApplicationContext.Provider>
}

export default ApplicationContext
